let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fZoyp")).then(() => parcelRequire('dy0HU'));